import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
  changePurchaseOrderStatus,
  confirmPurchaseOrder,
  rejectPurchaseOrder
} from 'features/summary/sagas/SummaryAPI';
import * as Actions from '../actions';
import { authTokenSelector, currentUserSelector } from '../selectors';
import { getEntity, getMe, changePassword } from './GlobalAPI';

function mergeMeIntoCurrentUser(currentUser, me) {
  if (!currentUser || !me) {
    return currentUser;
  }

  const role = me.role || {};
  const prevUser = currentUser.user || {};

  return {
    ...currentUser,
    status: {
      ...(currentUser.status || {}),
      ...(me.status || {})
    },
    user: {
      ...prevUser,
      id: me.id != null ? me.id : prevUser.id,
      name: me.name != null ? me.name : prevUser.name,
      email: me.email != null ? me.email : prevUser.email,
      theme_id: me.theme_id != null ? me.theme_id : prevUser.theme_id,
      // SCI entity usa user.theme ('dark'|'light'); /users/me usa theme_id.
      theme:
        me.theme_id != null
          ? Number(me.theme_id) === 2
            ? 'dark'
            : 'light'
          : prevUser.theme,
      role_id: role.id != null ? role.id : prevUser.role_id,
      role_identifier:
        role.identifier != null ? role.identifier : prevUser.role_identifier,
      role_name: role.name != null ? role.name : prevUser.role_name,
      role: role.id != null || role.name != null || role.identifier != null ? role : prevUser.role
    }
  };
}

function* changePurchaseOrderStatusWorker(action) {
  try {
    const { id, context, ...rest } = action.payload;
    const response = yield call(changePurchaseOrderStatus, id, rest);
    const {
      data: { status }
    } = response.data;
    if (status && status.id) {
      yield put(
        Actions.changePurchaseOrderStatusResponse({ success: status.id == rest.state, context })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

function getDeliveryStatusId(response) {
  const delivery = response?.data?.data;
  return delivery?.status?.id ?? delivery?.status_id;
}

function* confirmPurchaseOrderWorker(action) {
  const { id, context, ...rest } = action.payload;
  try {
    const response = yield call(confirmPurchaseOrder, id, rest);
    const statusId = getDeliveryStatusId(response);
    const success =
      statusId != null ? Number(statusId) === Number(rest.status_id) : response.status === 200;

    yield put(Actions.confirmPurchaseOrderResponse({ success, context }));
  } catch (error) {
    console.log(error);
    yield put(Actions.confirmPurchaseOrderResponse({ success: false, context }));
  }
}

function* rejectPurchaseOrderWorker(action) {
  const { id, context, ...rest } = action.payload;
  try {
    const response = yield call(rejectPurchaseOrder, id, rest);
    const statusId = getDeliveryStatusId(response);
    const success =
      statusId != null ? Number(statusId) === Number(rest.status_id) : response.status === 200;

    yield put(Actions.rejectPurchaseOrderResponse({ success, context }));
  } catch (error) {
    console.log(error);
    yield put(Actions.rejectPurchaseOrderResponse({ success: false, context }));
  }
}

function* manageSessionWorker(action) {
  try {
    const { token } = action.payload;
    const authToken = yield select(authTokenSelector);
    if (!token && !authToken) {
      yield put(Actions.userSignout());
    } else {
      if (!authToken) {
        yield put(Actions.setAuthToken(token));
      }

      let currentUser = yield select(currentUserSelector);
      if (!currentUser) {
        const response = yield call(getEntity);
        const { data } = response;
        yield put(Actions.setCurrentUser(data));
        currentUser = data;
      }

      // Nombre y rol del menú de perfil vienen de API /users/me
      try {
        const meResponse = yield call(getMe);
        const me = meResponse?.data?.data ?? meResponse?.data;
        const enriched = mergeMeIntoCurrentUser(currentUser, me);
        if (enriched && enriched !== currentUser) {
          yield put(Actions.setCurrentUser(enriched));
        }
      } catch (meError) {
        console.log(meError);
      }
    }
  } catch (error) {
    console.log(error);
  }
}

function* userSignoutWorker(action) {
  try {
    window.location.href = `${process.env.REACT_APP_SCI_HOST_URL}/salir`;
    yield put(Actions.setAuthToken(undefined));
    localStorage.removeItem('state');
  } catch (error) {
    console.log(error);
  }
}

function* changeUserPasswordWorker(action) {
  try {
    const response = yield call(changePassword, action.payload);
    console.log(response);
    yield put(Actions.changeUserPassswordResponse(response.status === 200));
  } catch (error) {
    yield put(Actions.changeUserPassswordResponse(false));
  }
}

function* globalSaga() {
  yield takeEvery(Actions.changePurchaseOrderStatusRequest.toString(), changePurchaseOrderStatusWorker);
  yield takeEvery(Actions.confirmPurchaseOrderRequest.toString(), confirmPurchaseOrderWorker);
  yield takeEvery(Actions.rejectPurchaseOrderRequest.toString(), rejectPurchaseOrderWorker);
  yield takeEvery(Actions.manageSession.toString(), manageSessionWorker);
  yield takeEvery(Actions.userSignout.toString(), userSignoutWorker);
  yield takeEvery(Actions.changeUserPasswordRequest.toString(), changeUserPasswordWorker);
}

export default globalSaga;
